import React, { type ReactNode } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import {
	AIRTABLE,
	AZURE_DEVOPS,
	GITHUB,
	GITLAB,
	JETBRAINS_YOUTRACK,
	LINEAR,
	NOTION,
	SMART_SHEET,
	WRIKE,
	type ImportType,
} from '../../../common/constants/import-type';
import messages from './messages';

const boldElement = (content: ReactNode) => <b>{content}</b>;

export const useGuide = (importType?: ImportType) => {
	const { formatMessage } = useIntl();

	const heading = formatMessage(messages.heading, { importType });
	switch (importType) {
		case GITHUB:
			return {
				heading,
				steps: [
					formatMessage(messages.githubStep1),
					formatMessage(messages.githubStep2, { b: boldElement }),
				],
			};
		case SMART_SHEET:
			return {
				heading,
				steps: [formatMessage(messages.smartsheetStep1, { b: boldElement })],
			};
		case LINEAR:
			return {
				heading,
				steps: [
					formatMessage(messages.linearStep1),
					formatMessage(messages.linearStep2, { b: boldElement }),
				],
			};
		case GITLAB:
			return {
				heading,
				steps: [
					formatMessage(messages.gitLabStep1),
					formatMessage(messages.gitLabStep2, { b: boldElement }),
					formatMessage(messages.gitLabStep3, { b: boldElement }),
				],
			};
		case AZURE_DEVOPS:
			return {
				heading,
				steps: [
					formatMessage(messages.azureDevopsStep1, { b: boldElement }),
					formatMessage(messages.azureDevopsStep2),
					formatMessage(messages.azureDevopsStep3, { b: boldElement }),
				],
			};
		case WRIKE:
			return {
				heading,
				steps: [
					formatMessage(messages.wrikeStep1, { b: boldElement }),
					formatMessage(messages.wrikeStep2, { b: boldElement }),
					formatMessage(messages.wrikeStep3, { b: boldElement }),
					formatMessage(messages.wrikeStep4),
				],
			};
		case JETBRAINS_YOUTRACK:
			return {
				heading,
				steps: [
					formatMessage(messages.jetbrainsStep1, { b: boldElement }),
					formatMessage(messages.jetbrainsStep2, { b: boldElement }),
				],
			};
		case AIRTABLE:
			return {
				heading,
				steps: [
					formatMessage(messages.airtableStep1),
					formatMessage(messages.airtableStep2, { b: boldElement }),
				],
			};
		case NOTION:
			return {
				heading,
				steps: [
					formatMessage(messages.notionStep1, { b: boldElement }),
					formatMessage(messages.notionStep2, { b: boldElement }),
					formatMessage(messages.notionStep3),
				],
			};
		default:
			return null;
	}
};
